import React, { useEffect, useRef, useState } from 'react';
import { Tree, Form, Typography } from 'antd';
import { Rule, FormInstance } from 'antd/es/form';
// Api
import { PromoCodesChargeSubject } from 'api/graphql-global-types';
// Components
import FormItemLabel from '../FormItemLabel/FormItemLabel';

const { Text } = Typography;

export const ALL_SITE_WIDE_KEYS = ['Merch', 'Ama', 'Stream'];
export const INTERNAL_SITE_WIDE_KEYS = ['Stream'];

export type SiteWideDataProps = {
  rules: Rule[] | undefined;
  form: FormInstance;
  onChange?: (checkedKeys: string[]) => void;
};

const SiteWideData: React.FC<SiteWideDataProps> = ({
  rules,
  form,
  onChange,
}) => {
  const isInternalCharging =
    form.getFieldValue('chargeSubject') === PromoCodesChargeSubject.Internal;

  const [checkedKeys, setCheckedKeys] = useState<string[]>(
    isInternalCharging ? INTERNAL_SITE_WIDE_KEYS : ALL_SITE_WIDE_KEYS
  );

  const applyCheckedKeys = (keys: string[]): void => {
    setCheckedKeys(keys);
    form.setFieldsValue({ siteWideOptions: keys });
    onChange?.(keys);
  };

  // Skip mount: the form's initial siteWideOptions includes types this tree
  // doesn't show, and overwriting it would drop them.
  const isFirstRender = useRef(true);

  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }

    applyCheckedKeys(
      isInternalCharging ? INTERNAL_SITE_WIDE_KEYS : ALL_SITE_WIDE_KEYS
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isInternalCharging]);

  const treeData = [
    {
      title: 'Merch Products',
      key: 'Merch',
      disabled: isInternalCharging,
    },
    // TODO: add 'AMAs' back and hide 'Ama' when Shoutout feature will be turned on
    // {
    //   title: 'AMAs',
    //   key: 'Amas',
    //   children: [
    //     {
    //       title: 'Ama',
    //       key: 'Ama',
    //     },
    //     {
    //       title: 'Shoutout',
    //       key: 'Shoutout',
    //     },
    //   ],
    // },
    {
      title: 'Ama',
      key: 'Ama',
      disabled: isInternalCharging,
    },
    {
      title: (
        <>
          Stream <Text type="secondary">· preset discounts only</Text>
        </>
      ),
      key: 'Stream',
    },
  ];

  const onCheck = (
    checked:
      | React.ReactText[]
      | { checked: React.ReactText[]; halfChecked: React.ReactText[] }
  ): void => {
    const keys = (Array.isArray(checked) ? checked : checked.checked)
      .filter((item) => item !== 'Amas')
      .map(String);

    applyCheckedKeys(keys);
  };

  return (
    <Form.Item
      name="siteWideOptions"
      label={<FormItemLabel labelText="Products List" />}
      rules={rules}
    >
      <Tree
        checkable
        defaultExpandAll
        selectable={false}
        // TODO: add 'Shoutout' back in defaultCheckedKeys when Shoutout feature will be turned on
        checkedKeys={checkedKeys}
        onCheck={onCheck}
        treeData={treeData}
      />
    </Form.Item>
  );
};

export default SiteWideData;
